import find from 'lodash/find';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import React from 'react';
import { register } from '../lib/authApi';
import { checkOrgRegistered } from '../lib/authApi';
import { checkUserRegistered } from '../lib/authApi';
import Wizard from './components/Wizard';
import { ValidFormData } from './components/Wizard.type';
import { FormData } from './components/Wizard.type';
import { WizardStep } from './components/WizardStep';
import { createSecondStepValidationSchema } from './lib/validationSchema';
import { createFirstStepValidationSchema } from './lib/validationSchema';
import { RegistrationProps } from './Registration.type';
import { RegistrationFirstStep } from './RegistrationFirstStep';
import { RegistrationSecondStep } from './RegistrationSecondStep';

const checkUserRegistrationAvailable = async (login: string) => {
    if (login) {
        try {
            const registered = await checkUserRegistered({ login });
            return !registered;
        } catch (err: any) {}
    }
    return true;
};

const checkOrgRegistrationAvailable = async (inn: string, kpp?: string) => {
    if (inn) {
        try {
            const registered = await checkOrgRegistered({ inn, kpp });
            return !registered;
        } catch (err: any) {}
    }
    return true;
};

const firstStepValidationSchema = createFirstStepValidationSchema({
    checkUserRegistrationAvailable,
});
const secondStepValidationSchema = createSecondStepValidationSchema({
    checkOrgRegistrationAvailable,
});

export const Registration: React.FC<RegistrationProps> = ({
    orgTypes,
    orgForms,
    regions,
}) => {
    const router = useRouter();

    const initialValues = useMemo<FormData>(
        () => ({
            user: {
                email: '',
                password: '',
                lastName: '',
                firstName: '',
                secondName: '',
                workPhone: '',
            },
            organization: {
                role: null,
                orgType: find(orgTypes, ['title', 'Юридическое лицо']) || null,
                orgForm: find(orgForms, ['abbrev', 'ООО']) || null,
                fullName: '',
                inn: '',
                kpp: '',
                isFilial: false,
                headKpp: '',
                region: null,
            },
            personal: false,
        }),
        [orgForms, orgTypes]
    );

    const handleSubmit = async (values: FormData) => {
        await register(values as ValidFormData);
        router.push('/auth/registration/success');
    };

    return (
        <Wizard initialValues={initialValues} onSubmit={handleSubmit}>
            <WizardStep validationSchema={firstStepValidationSchema}>
                <RegistrationFirstStep />
            </WizardStep>

            <WizardStep validationSchema={secondStepValidationSchema}>
                <RegistrationSecondStep
                    orgTypes={orgTypes}
                    orgForms={orgForms}
                    regions={regions}
                />
            </WizardStep>
        </Wizard>
    );
};
